<template>
  <div class="analysis_warp"
       @click="handleClick">
    <div class="top">
      <TopCard ref="TopCardRef"
               text="AI答疑"
               :showBack="true" />
    </div>

    <div class="content">
      <div class="left">
        <a-menu v-model:openKeys="openKeys"
                v-model:selectedKeys="selectedKeys"
                mode="inline"
                :inline-collapsed="collapsed">

          <a-menu-item key="1">
            <div class="add"
                 @click="isCollapse = !isCollapse"
                 v-if="isCollapse">
              <img src="@/static/AI/Plus.png"
                   alt="">
            </div>
            <div class="left_tree">

              <div class="chat-gpt"
                   v-show="!isCollapse">
                <div class="chat-gpt-left">

                  <div class="item_btn"
                       @click="createNewChat"> <img src="@/static/AI/Plus.png"
                         alt="">开启新对话</div>
                  <div class="line"></div>
                  <div class="search">
                    <div class="searchInput"
                         v-show="!isShowDel">
                      <a-input placeholder="请输入内容"
                               prefix-icon="el-icon-search"
                               @change="inputChange"
                               style="width:70%"
                               v-model:value="inputSearch">
                      </a-input>
                      <div @click="delShow"
                           class="image_btn">
                        <img src="@/static/AI/Trash.png"
                             style="width: 20rem;height: 20rem;"
                             alt="">
                      </div>
                    </div>
                    <div class="searchInput"
                         v-show="isShowDel">
                      <div class="btn1"
                           @click="delShow"> <img src="@/static/AI/close.png"
                             style="width: 20rem;height: 20rem;color:#666"
                             alt="">取消</div>
                      <div class="btn"
                           @click="del"> <img src="@/static/AI/del.png"
                             style="width: 20rem;height: 20rem;"
                             alt="">删除</div>
                    </div>
                  </div>
                  <!-- 聊天列表 -->

                  <div class="left_list">
                    <div class="item_c_list"
                         v-for="(chat, index) in chatList"
                         :key="index">
                      {{ index }}
                      <div class="item_c"
                           :class="{ active: activeIndex.index == index && activeIndex.childindex == childindex }"
                           v-for="(chatchild, childindex) in chat"
                           :key="childindex"
                           @click="selectChat(index,childindex,chatchild)">
                        <div v-show="isShowDel">
                          <img src="@/static/AI/check.png"
                               v-if="selectUUid.includes(chatchild.group_uuid)"
                               style="width: 20rem;height: 20rem;"
                               alt="">
                          <img src="@/static/AI/circle.png"
                               v-else
                               style="width: 20rem;height: 20rem;"
                               alt="">
                        </div>
                        <div>
                          {{ chatchild.title||chatchild.list.title }}
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div :style="{ 'margin-top' :isCollapse? '730rem' : '0rem' ,}"
                   class="collapse"
                   @click="isCollapse = !isCollapse">

                <MenuFoldOutlined v-if="!isCollapse" />
                <MenuUnfoldOutlined v-else />
              </div>
            </div>
          </a-menu-item>

        </a-menu>
      </div>
      <div class="chat-gpt-right"
           v-if="currentChat !== null">
        <div class="input-area-tit"
             v-if="isFirst">
          <div class="text">我是善利AI小助手，备考之路，有我相伴！</div>
          <div class="text1">我可以帮你解答学习中的疑问，欢迎提问~</div>
        </div>
        <div class="chat-area">
          <div v-for="(message, index) in currentChat.messages"
               :key="index"
               class="message">
            <!-- 根据消息发送者动态添加样式 -->
            <div v-if="message.sender === 'me'||message.question"
                 class="message-bubble user-message"
                 :ref="`userMessage-${index}`">
              <div style="display:flex;flex-direction: column;align-items: flex-end;">
                <div class="c_cont">{{ message.text||message.question}}</div>
                <div class="c_cont1"
                     v-if="message.img"> <img style="margin-top:12rem"
                       :src="message.img"></div>
                       <div class="c_cont1"
                       v-if="message.file?message.file:message.fileInfo?message.fileInfo.fileName:'' ">   <div class="fileChat">
                     
 
            <img src="@/static/AI/file.png"
                 style="width: 32rem;height: 32rem;"
                
                 alt="">
            <div style="display:flex;flex-direction: column;">
              <div class="text">
                <div class="imgText">{{message.fileInfo?message.fileInfo.fileName:message.file_info[0].filename }}</div>


                <img src="@/static/AI/close.png"
                     @click="closeImg"
                     style="width: 16rem;height: 16rem;"
                     alt="">
              </div>
              <div class="imgText">{{fileSizeInMB1(message.fileInfo ?message.fileInfo.fileSize:message.file_info[0].bytes) }}</div>
            </div>
          </div>
          </div>
              </div>
              <div class="c_name"><img src="@/static/AI/me.png"
                     alt=""></div>
            </div>
            <div v-if="message.isLoading"
                 class="message-bubble machine-responseload">
              <div class="c_name"><img src="@/static/AI/logo.png"
                     alt=""></div>
              <a-skeleton class="skeleton"
                          :paragraph="{ rows: 2 }"
                          style="background: #FFF;"
                          active />
            </div>
            <div v-if="(message.sender === 'machine'|| message.content)&&!(message&&message.isLoading==true)"
                 class="message-bubble machine-response">
              <div class="c_name"> <img src="@/static/AI/logo.png"
                     alt=""></div>
              <div style="display:flex;flex-direction: column;">
                <div v-if="message.reasoning_content"
                     @click="show(message)"
                     class="c_title">深度思考已完成
                  <up-outlined v-if="!showTextStatus[message.id]" />
                  <down-outlined v-else />

                </div>
                <div class="c_contdeep"
                     v-if="message.reasoning_content&&!showTextStatus[message.id]"
                     v-html="formattedMessage( message.reasoning_content)"></div>
                <div class="c_cont "
                     v-html="formattedMessage( message.content)"></div>
              </div>
            </div>
            <div class="message-bubble c_res"
                 v-if="message.sender === 'machine'|| message.content">
              <div style="display:flex;cursor:pointer;">
                <div @click="getResend(message)"> <img src="@/static/AI/res.png"
                       alt="">重答
                </div>
                <div :id="`share-${index}`"
                     :data-clipboard-text="message.content"
                     @click="copy(index)"> <img src="@/static/AI/copy.png"
                       alt="">复制
                </div>
              </div>
              <div class="c_page"
                   v-show="message.resData&&message.resData.length>1&&!message.isLoading"><left-outlined @click="previous(pageIndex,message)" /> {{message.index}}/{{message.resData?message.resData.length:"1"}}

                <right-outlined @click="next(pageIndex,message)" />
              </div>
            </div>

          </div>

        </div>
         <div class="selectDialog" v-show="isshowSelect" :style="{'top': isFirst ? '' : '546rem'}">
          <div class="item" @click="selectTypeClick(0)"><img src="@/static/AI/ds.png"
                 style="width: 20rem;height: 20rem;"
                 alt="">DeepSeek</div>
            <div class="item"  @click="selectTypeClick(1)"><img src="@/static/AI/ty.png"
                 style="width: 20rem;height: 20rem;"
                 alt="">通义千问</div>
        </div>
        <div class="selectType" @click="showSelect" :style="{'top': isFirst ? '' : '671rem'}"> <img src="@/static/AI/ty.png"
          v-if="modelType==1"
                 style="width: 20rem;height: 20rem;"
                 alt=""><img src="@/static/AI/ds.png"
                 v-else
                 style="width: 20rem;height: 20rem;"
                 alt="">{{modelType==1?"通义千问":"DeepSeek"}}  <up-outlined v-if="isshowSelect" />
                  <down-outlined v-else /></div>
        <div class="input-area"
             @keydown="handleKeyDown"
             :style="{'margin-bottom': isFirst ? '200rem' : '0'}">
          <a-textarea v-model:value="formData.inputMessage"
                      :auto-size="{ minRows: 7 }"
                      placeholder="请输入提问内容/给AI发消息"
                      :disabled="isRobotReplying"></a-textarea>
          <div class="fileList"
               :style="{'margin-bottom': isFirst ? '-31rem' : '-230rem',}"
               v-show="fileName">

            <img src="@/static/AI/img.png"
                 v-if="type=='img'"
                 style="width: 32rem;height: 32rem;"
                 alt="">
            <img src="@/static/AI/file.png"
                 style="width: 32rem;height: 32rem;"
                 v-else
                 alt="">
            <div style="display:flex;flex-direction: column;">
              <div class="text">
                <div class="imgText">{{fileName}}</div>

                <img src="@/static/AI/close.png"
                     @click="closeImg"
                     style="width: 16rem;height: 16rem;"
                     alt="">
              </div>
              <div class="imgText">{{fileSizeInMB }}</div>
            </div>
          </div>
          <div style="display: flex;gap:8rem" v-show="modelType==0">
            <div @click="deep"

                       :style="{'margin-bottom': isFirst ? '200rem' : '0',}"
                       :class="button==1?'send_buttonActive':'send_button1' "
                       round>
              <div><img src="@/static/AI/Brain-active.png"
                     style="width: 20rem;height: 20rem;"
                     v-if="button==1"
                     alt=""><img src="@/static/AI/Brain.png"
                     v-else
                     style="width: 20rem;height: 20rem;"
                     alt="">深度思考</div>
              </div>
            <div @click="quick"

                       :style="{'margin-bottom': isFirst ? '200rem' : '0'}"
                      :class="button==0?'send_buttonActive2':'send_button2' "
                       round>
              <div><img src="@/static/AI/Lightning-active.png"
                     v-if="button==0"
                     style="width: 20rem;height: 20rem;"
                     alt=""><img src="@/static/AI/Lightning.png"
                v-else
                     style="width: 20rem;height: 20rem;"
                     alt="">快速答疑</div>
              </div>
          </div>
          <div class="uploadDialog"
               v-show="uploadFlag"
               :style="{'margin-bottom': isFirst ? '0rem' : '-174rem'}">
            <div class='text1'
                 @click="triggerImageUpload('img')">图片理解</div>
            <div class='text2'
                 @click="triggerFileUpload('file')">文档解析</div>
            <!-- 文件输入元素 -->
            <input type="file"
                   ref="imageInput"
                  
                   @change="handleImageChange"
                   accept="image/*,"
                   style="display: none;">
            <input type="file"
                   ref="fileInput"
                     
                   @change="handleImageChange"
                   accept=".txt,.docx,.pdf,.xlsx,.epub,.mobi,.md,.csv,.bmp"
                   style="display: none;">
          </div>
          <div class="upload"
          v-show="modelType==1"
               @click="showUpload"
               :style="{'margin-bottom': isFirst ? '0rem' : '-199rem'}">
 
            <img src="@/static/AI/PlusCircle.png"
                 style="width: 40rem;height: 40rem;"
                 alt="">
          </div>

          <a-button type="primary"
                    class="send_button"
                    :style="{'margin-bottom': isFirst ? '200rem' : '0'}"
                    @click="sendMessage"
                    :disabled="isRobotReplying">发送</a-button>
        </div>
        <div class="bottom_text">内容由AI生成，请仔细甄别</div>
      </div>

      <div class="chat-gpt-right"
           v-else>
        <div>
          <p>请选择一个聊天</p>
        </div>
      </div>

    </div>
    <div ref="mod"> <a-modal :get-container="() => $refs.mod"
               v-model:visible="visible"
               title="删除对话"
               style="width: 480rem;"
               ok-text="删除"
               cancel-text="取消">
        <p>删除后，对话将不可恢复。确认删除吗？</p>
        <template #footer>

          <a-button @click="handleCancel">取消</a-button>
          <a-button type="primary"
                    @click="delItem">确定</a-button>

        </template>
      </a-modal></div>

  </div>

</template>

<script>
import TopCard from '@/views/components/top_card/index.vue'
// import TopicInfo from '@/views/paper_components/correct/components/opertion.vue'
import { sendQuestion, getChatList, getChatInfo, resend, delChat, uploadFile, uploadImg, getModelList, getTypeList } from '@/api/chat.js'
// import { marked } from 'marked';
import marked from 'marked';
import Clipboard from 'clipboard';
import cloneDeep from 'lodash/cloneDeep';
import { MenuUnfoldOutlined, MenuFoldOutlined, UpOutlined, DownOutlined, ExclamationCircleOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons-vue'
import { message, Modal } from 'ant-design-vue'
import { createVNode } from 'vue';
import getMd5Form from '@/utils/getMd5Form.js'
import { fetchEventSource } from '@microsoft/fetch-event-source';

export default {
  data () {
    return {
      isFirst: true,
      optimizedCode: false,
      formData: {
        inputMessage: ''
      },
      inputSearch: null,
      isCollapse: false,
      messages: [],
      showTextStatus: {},
      chatList: [], // 存储聊天列表
      currentChat: { messages: [], title: '' }, // 存储当前选中的聊天
      activeIndex: { chatIndex: -1, childIndex: -1 },
      isRobotReplying: false, // 添加 isRobotReplying 属性
      userinfo: null,
      button: null,
      pageIndex: 1,
      isShowDel: false,
      selectUUid: [],
      buttonList: [],
      isShowText: true,
      resIndex: 0,
      uuid: null,
      copyMessages: null,
      visible: false,
      uploadFlag: false,
      file: null,
      img: null,
      filePath: null,
      fileID: null,
      imgInfo: { filePath: null },
      fileName: '',
      fileInfo:'',
      type: null,
      fileSize: null,
        modelType:1,
      isshowSelect:false,
    }
  },
  components: {
    TopCard, MenuFoldOutlined, MenuUnfoldOutlined, UpOutlined, DownOutlined, ExclamationCircleOutlined, LeftOutlined, RightOutlined
  },
  computed: {
    fileSizeInMB () {
      if (this.fileSize < 1024) {
        return this.fileSize + 'B';
      } else if (this.fileSize < 1024 * 1024) {
        return (this.fileSize / 1024).toFixed(2) + 'KB';
      } else {
        return (this.fileSize / (1024 * 1024)).toFixed(2) + 'MB';
      }
    },

  },
  created () {
    this.userinfo = JSON.parse(window.localStorage.getItem('userInfo'))

  },
  mounted () {
    // this.createNewChat()
    this.getChat()

  },
  methods: {
    fileSizeInMB1 (val) {
      if (val < 1024) {
        return val + 'B';
      } else if (val < 1024 * 1024) {
        return (val/ 1024).toFixed(2) + 'KB';
      } else {
        return (val / (1024 * 1024)).toFixed(2) + 'MB';
      }
    
    },
    handleClick (event) {
      const dialog = this.$el.querySelector('.uploadDialog');
      const dialog2 = this.$el.querySelector('.upload');
      console.log('dialog', dialog2.contains(event.target))
      if (dialog2.contains(event.target)) {
        return
      }
      if (dialog && !dialog.contains(event.target)) {
        // alert(3)
        this.uploadFlag = false
      }
    },
    show (message) {
      console.log('mes', message.id)
      const messageId = message.id; // 假设每条消息都有一个唯一的 id
      // this.$set(this.showTextStatus, messageId, !this.showTextStatus[messageId]);
      this.showTextStatus[messageId] = !this.showTextStatus[messageId];
    },
    copy (id) {
      var clipboard = new Clipboard(`#share-${id}`);
      clipboard.on("success", (e) => {
        this.$message.success('复制成功')
        // 释放内存
        clipboard.destroy();
      });
    },
        showSelect(){
this.isshowSelect = !this.isshowSelect
    },
    selectTypeClick(val){
this.modelType = val
if(this.modelType==0){
  this.button = 1
}
this.isshowSelect = false
    },
    handleBlur (refName) {
      // this.button = 3
      if (this.buttonList.length == 2) return
      this.buttonList.push(refName)
    },
    next (indexpage, message) {
      console.log('message08888', indexpage, this.copyMessages);

      // this.copyMessages = cloneDeep(this.currentChat.messages);

      this.pageIndex = indexpage
      const index = this.currentChat.messages.findIndex(msg => msg.seq === message.seq);
      if (this.pageIndex == this.copyMessages[index].resData.length) {

        return
      }
      // alert(99)
      console.log("this.currentChat.messages", this.currentChat.messages)

      // console.log("index", index)
      // 使用this.$set来确保Vue能够检测到变化并更新视图
      // if (index !== -1) {
      console.log('this.copyMessages[0].resData[this.pageIndex]', this.copyMessages[index].resData[this.pageIndex]);
      console.log('this.currentChat.messages[index]', this.currentChat.messages[index]);
      // this.$set(this.currentChat.messages[index], 'content', this.copyMessages[index].resData[this.pageIndex].content);
      // this.$set(this.currentChat.messages[index], 'reasoning_content', this.copyMessages[index].resData[this.pageIndex].reasoning_content);
      this.currentChat.messages[index].content = this.copyMessages[index].resData[this.pageIndex].content;
      this.currentChat.messages[index].reasoning_content = this.copyMessages[index].resData[this.pageIndex].reasoning_content;

      this.pageIndex = this.pageIndex + 1
      // this.$set(this.currentChat.messages[index], 'index', this.pageIndex);
      this.currentChat.messages[index].index = this.pageIndex;

      // }

    },
    previous (indexpage, message) {
      // console.log('message08888', message,this.copyMessages[index]);
      // this.copyMessages = cloneDeep(this.currentChat.messages);
      console.log('message088777788', this.copyMessages);
      this.pageIndex = indexpage
      if (this.pageIndex > 0) { // 确保pageIndex大于0，避免数组越界

        const index = this.currentChat.messages.findIndex(msg => msg.seq === message.seq);
        // 使用this.$set来确保Vue能够检测到变化并更新视图
        if (index !== -1) {
          if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
          }

          console.log('this早上', this.pageIndex, this.copyMessages[index]);


          // this.$set(this.currentChat.messages[index], 'content', this.copyMessages[index].resData[this.pageIndex-1].content);
          this.currentChat.messages[index].reasoning_content = this.copyMessages[index].resData[this.pageIndex - 1].reasoning_content;

          // this.$set(this.currentChat.messages[index], 'reasoning_content', this.copyMessages[index].resData[this.pageIndex-1 ].reasoning_content);
          this.currentChat.messages[index].content = this.copyMessages[index].resData[this.pageIndex - 1].content;
          // }

          // this.$set(this.currentChat.messages[index], 'index', this.pageIndex);
          this.currentChat.messages[index].index = this.pageIndex;

        }
      } else {
        console.log('已到达最前一条消息');
      }
    },
    formattedMessage (val) {
     let formattedVal = val
        .replace(/\\int/g, '∫')
        .replace(/\\frac\{([^}]*)\}\{([^}]*)\}/g, '($1)/($2)')
        .replace(/\\neq/g, '≠')
        .replace(/\\quad/g, ' ');
      return marked(formattedVal);
    },
    async getResend (val) {

      let resIndex = val.seq - 1

      console.log('rescurrentChat.messagess', resIndex, this.currentChat.messages)
      console.log('val', val)
      const index = this.currentChat.messages.findIndex(msg => msg.seq == val.seq);

      // this.$set(this.currentChat.messages[resIndex], "isLoading", true);
      this.currentChat.messages[resIndex].isLoading = true;
      const { data } = await resend({ remote_id: val.remote_id });

      // 确保不引入循环引用，避免直接将val推入arr
      let arr = val.resData || []

      if (arr.length === 0) {
        // 只推入val中除了resData的部分数据
        arr.push({ ...val, resData: undefined })
      }
      arr.push(data)
      val.resData = arr


      // 使用this.$set来确保Vue能够检测到变化并更新视图
      if (index !== -1) {
        // this.$set(this.currentChat.messages, index, val);
        this.currentChat.messages[index] = val;
      }
      console.log('88899', this.currentChat.messages)
      // this.$set(this.currentChat.messages[resIndex], "isLoading", false);
      this.currentChat.messages[resIndex].isLoading = false;
      this.getInfo()
      // this.copyMessages = cloneDeep(this.currentChat.messages);
      console.log('888777799', this.currentChat.messages)
      setTimeout(() => {
        this.copyMessages = cloneDeep(this.currentChat.messages);
        this.next(this.currentChat.messages[resIndex].resData.length - 1, data)

      }, 2000)

    },
    handleCancel () {
      this.visible = false
    },
    async delItem () {
      if (this.selectUUid.length == 0) {
        message.success('请选择删除对话')
        return
      }

      let form = {
        uid: this.userinfo.user_id,
        platform: 1,
        uuid: this.selectUUid.join(','),
      }

      const data = await delChat(form)
      if (data.status == 200) {
        message.success('删除成功')
        this.isShowDel = false
        this.visible = false
        this.getChat()
      }
    },
    del () {
      if (this.selectUUid.length == 0) {
        message.success('请选择删除对话')
        return
      }
      this.visible = true
    },

    delShow () {
      this.selectUUid = []
      this.isShowDel = !this.isShowDel
      console.log('ssss', this.isShowDel)
    },
    inputChange (val) {
      this.getChat()
    },
    showUpload () {
      if (this.filePath) {
        return
      }
      this.uploadFlag = !this.uploadFlag
    },
    handleImageChange (event) {
      const file = event.target.files[0]; // 获取选择的文件
      console.log('file', file);
      this.fileName = file.name; // 获取文件名



      if (file) {

        this.file = file; // 将文件赋值给 img
        this.upload(this.file); // 调用 upload 函数上传图片
      }
      event.target.value = '';
      this.uploadFlag = false
    },
    triggerFileUpload  (type) {
  
  this.type = type
 

  this.$refs.fileInput.click(); // 触发文件选择对话框
},
    triggerImageUpload (type) {
  
      this.type = type
 

      this.$refs.imageInput.click(); // 触发文件选择对话框
    },
    async upload (file) {

      let formdata = new FormData();
      formdata.append("file", file);

      formdata.append("filename", "file")
      let form = {
        filename: "file"
      }
      formdata.append('sign', getMd5Form(form, '/api/rpc/'))
      // console.log('type',this.type);

      if (this.type == 'img') {

        const { data } = await uploadImg(formdata)

        this.filePath = data.filePath
        this.fileSize = data.fileSize
        this.imgInfo = data

      } else {

        const { data } = await uploadFile(formdata)

        this.fileID = data.id
        this.fileSize = data.bytes
        console.log('fileSize', this.fileSize)

      }

    },
    handleKeyDown (event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        // 这里执行发送消息的逻辑
        this.sendMessage();
      }
    },
    closeImg () {
      this.fileName = ''
      this.fileID = ''
      this.filePath = ''
    },
    quick (val) {
      // this.buttonList = []
      // this.buttonList.push(0)
      this.button = 0
    },
    deep () {
      // this.buttonList = []
      // this.buttonList.push(1)
      this.button = 1
    },
    async getChat (val) {
      let form = {
        uid: this.userinfo.user_id,
        platform: 1,

        key: this.inputSearch
      }
      const { data } = await getChatList(form)

      this.chatList = data

      this.createNewChat()



    },
    // 创建新聊天
    createNewChat () {
      this.uuid = ""
      const newChat = {
        title: '新的对话', // 聊天标题
        messages: [], // 聊天消息
      };
      console.log('thisssss', this.chatList);
      this.isFirst = true
      this.activeIndex = { chatIndex: -1, childIndex: -1 }
      // 检查是否存在 today 对象


      // if (!this.chatList.today) {
      //   // 如果不存在 today 对象，则创建并添加到最前面
      //   this.chatList = {
      //     today: [],
      //     ...this.chatList
      //   };
      //   this.chatList.today.unshift(newChat);
      // } else {
      //   // 如果存在 today 对象，则在其中添加新的聊天
      //   this.chatList.today.unshift(newChat);
      // }
      this.currentChat.messages = [];
      this.formData.inputMessage = '';
      // 恢复发送按钮和输入数据
      this.isRobotReplying = false;
      // this.selectChat(this.chatList.length - 1); // 选择新创建的聊天
    },
    // 选择聊天
    // selectChat (index) {
    //   this.currentChat = this.chatList[index];
    //   this.activeIndex = index
    // },
    async getInfo () {

      let form = {
        uid: this.userinfo.user_id,
        platform: 1,
        uuid: this.uuid,
      }
      const { data } = await getChatInfo(form)
      const resData = [];

      data.forEach(item => {
        if (!resData[item.seq]) {
          resData[item.seq] = [];
        }
        // console.log('item',item.seq);

        resData[item.seq].push(item);
      });




      data.forEach(item => {
        resData.forEach((item1) => {
          console.log('item', item);
          console.log('item1', item1);
          if ((item.seq == item1[0].seq) && item.index == 1) {
            // console.log('tem',item);
            item.resData = item1
          }
        })


      });
      this.currentChat.messages = data.filter(item => item.index == 1);
    },
    async selectChat (index, childindex, chatchild) {
      // console.log('chatchild', chatchild)
      this.uuid = chatchild.group_uuid
      window.localStorage.setItem('uuid', this.uuid)
      if (this.isShowDel) {
        if (this.selectUUid.includes(chatchild.group_uuid)) {
          const index = this.selectUUid.indexOf(chatchild.group_uuid);
          if (index > -1) {
            this.selectUUid.splice(index, 1);
          }
        } else {
          this.selectUUid.push(chatchild.group_uuid)
        }
      }


      let form = {
        uid: this.userinfo.user_id,
        platform: 1,
        uuid: chatchild && chatchild.group_uuid ? chatchild.group_uuid : "",
      }

      this.isFirst = false
      const { data } = await getChatInfo(form)

      data.forEach(item => {
        item.sender = 'me'
      })
      const resData = [];

      data.forEach(item => {
        if (!resData[item.seq]) {
          resData[item.seq] = [];
        }
        // console.log('item',item.seq);

        resData[item.seq].push(item);
      });




      data.forEach(item => {
        resData.forEach((item1) => {
          console.log('item', item);
          console.log('item1', item1);
          if ((item.seq == item1[0].seq) && item.index == 1) {
            console.log('this', this);
            // this.$set(item, 'resData', item1);
            item.resData = item1

          }
        })


      });
      // console.log('dat8888888a',data);

      this.currentChat.messages = data.filter(item => item.index == 1);
      this.copyMessages = cloneDeep(this.currentChat.messages);
      // this.isFirst = false
      this.activeIndex = { index, childindex };
    },
    // 编辑聊天
    editChat () {
      // 处理编辑聊天的逻辑
      console.log(1);

    },
    // 删除聊天
    deleteChat (index) {
      this.chatList.splice(index, 1);
      if (this.chatList.length > 0) {
        this.selectChat(0); // 选择第一个聊天
        this.activeIndex = 0
      } else {
        this.currentChat = null; // 如果没有聊天了，清空当前聊天
        this.activeIndex = null
      }
    },
    async sendMessage () {
      if (this.button == 3 || this.formData.inputMessage == "") {
        return
      }
      console.log('this.currentChat', this.currentChat);

      this.isFirst = false
      const userMessage = this.formData.inputMessage;

      const currentChatNow = this.currentChat; // 获取当前选中的聊天
      // 设置标题，您可以根据需要更改
      currentChatNow.title = userMessage;

      // 禁用发送按钮和输入数据
      this.isRobotReplying = true;

      // 用户消息
      const userMessageObj = { sender: 'me', question: userMessage, isLoading: true, img: this.filePath,fileInfo:{fileName:this.fileName,fileSize:this.fileSize  } };
      currentChatNow.messages.push(userMessageObj);

      // const userMessageLetters = userMessage.split(''); // 将用户消息拆分成字母数组

      // for (const letter of userMessageLetters) {
      //  userMessageObj.text += letter;
      //   await this.delay(100); // 添加延迟以逐字显示
      // }
      let form = {
        uid: this.userinfo.user_id,
        platform: 1,
        uuid: this.uuid ,
        content: userMessage,
        type:this.modelType,
model:this.modelType==0?this.button:2,
        img: this.filePath ? this.filePath.replace(/\\/g, '') : '',
        file: this.fileID,
      }
      this.fileName = ''
      // const { data } = await sendQuestion(form)
      let appToken = JSON.parse(window.localStorage.getItem('appToken'))

      const signedForm = getMd5Form(form, '/api/rpc/')
      form.sign = signedForm
      let textdata = {content:'',reasoning_content:''}
      let data = {}
      let stop = null
       var url = process.env.NODE_ENV === 'development' ? "http://10.10.11.250:805" : 'https://slbk.sunrayai.cn'
      const evt = await fetchEventSource(url+'/api/rpc/ai/chat/sse_send', {
        method: 'POST',          // 使用POST方法
        headers: {
          'Content-Type': 'application/json;',
          'Authorization': `Bearer ${appToken.token}`
        },
        body: JSON.stringify(form),

        onmessage (ev) {
        
          if (ev.event == "end_error") {
              console.error('Eevevevev:', ev);
            stop = ev.event
            textdata.content+= ev.data;
      } else  if (ev.event == "end_success") {
        data = JSON.parse(ev.data)
        data.content = textdata.content;
      } else if (ev.event == "chat") {
        textdata.content+= ev.data;
      } else if (ev.event == "reasoner") {
        textdata.reasoning_content+= ev.data;
      } else {
        console.log(ev.event, ev.data);
      }
        
        },
        onerror (err) {
          console.error('EventSource error:', err);
        }
      });
      console.log('data',data);
      this.uuid = data.group_uuid?data.group_uuid:  window.localStorage.getItem('uuid') 
      // 模糊匹配用户消息与 chatData.json 中的问题
      // const matchedQuestion = this.matchQuestion(userMessage);
      if(stop=='end_error'){
message.error(textdata.content, 5);
 this.currentChat.messages.pop()
 this.formData.inputMessage = '';
 this.filePath = ''
 this.fileID = ''
this.isRobotReplying = false;
 
}
      if (data.content) {

        userMessageObj.isLoading = false
        const answer = data.content;
        // 机器回复
        const machineResponseObj = Object.assign({ sender: 'machine' }, data);
        currentChatNow.messages.push(machineResponseObj);

        const answerLetters = answer.split(''); // 将回复拆分成字母数组

        for (const letter of answerLetters) {
          machineResponseObj.content += letter;
          // await this.delay(100); // 添加延迟以逐字显示
        }
      } else {
        // 如果未找到匹配的问题，尝试查找类似的问题并返回相关答案
        const similarQuestion = this.findSimilarQuestion(userMessage);

        if (similarQuestion) {
          const answer = similarQuestion.answer;
          // 机器回复
          const machineResponseObj = { sender: 'machine', text: '' };
          currentChatNow.messages.push(machineResponseObj);

          const answerLetters = answer.split(''); // 将回复拆分成字母数组

          for (const letter of answerLetters) {
            machineResponseObj.text += letter;
            await this.delay(100); // 添加延迟以逐字显示
          }
        } else {
          // 如果找不到相似的问题，您可以提供默认回复或其他处理逻辑
          const defaultResponse = '抱歉，我暂时无法回答您的问题。';
          // 机器回复
          const machineResponseObj = { sender: 'machine', text: '' };
          currentChatNow.messages.push(machineResponseObj);

          const defaultResponseLetters = defaultResponse.split(''); // 将默认回复拆分成字母数组

          for (const letter of defaultResponseLetters) {
            machineResponseObj.text += letter;
            await this.delay(100); // 添加延迟以逐字显示
          }
        }

      }
      this.formData.inputMessage = '';

      // 恢复发送按钮和输入数据
      this.isRobotReplying = false;
      this.filePath = ''
      let forms = {
        uid: this.userinfo.user_id,
        platform: 1,

        key: this.inputSearch
      }
      setTimeout(async () => {
        const { data: chatData } = await getChatList(forms);
        this.chatList = chatData;

      }, 3000)
      this.getInfo()

    },
    async typeResponse (response, currentChatNow) {
      const characters = response.split('');
      for (const char of characters) {
        await this.delay(100); // 延迟控制逐字显示速度，可以根据需要调整
        currentChatNow.messages[currentChatNow.messages.length - 1].text += char;
      }
    },
    // 添加延迟函数
    delay (ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    // 模糊匹配用户消息与 chatData.json 中的问题
    matchQuestion (userMessage) {
      const lowerCaseUserMessage = userMessage.toLowerCase();
      let bestMatch = null;
      let bestRatio = 0;

      for (const questionData of chatData) {
        const lowerCaseQuestion = questionData.question.toLowerCase();
        const similarityRatio = this.calculateSimilarity(lowerCaseUserMessage, lowerCaseQuestion);

        if (similarityRatio > bestRatio) {
          bestRatio = similarityRatio;
          bestMatch = questionData;
        }
      }

      // 只有当相似度大于某个阈值时才返回匹配的问题，否则返回 null
      if (bestRatio >= 0.7) {
        return bestMatch;
      } else {
        return null;
      }
    },
    // 定义 findSimilarQuestion 方法
    findSimilarQuestion (userMessage) {
      // 创建一个数组来存储匹配程度最高的问题
      let bestMatchedQuestions = [];
      let bestMatchRatio = 0;

      // 遍历 chatData 中的问题，计算与用户消息的相似度
      for (const questionData of chatData) {
        const similarityRatio = this.calculateSimilarity(userMessage.toLowerCase(), questionData.question.toLowerCase());

        // 如果相似度高于阈值，将问题添加到最佳匹配问题数组中
        if (similarityRatio > bestMatchRatio) {
          bestMatchedQuestions = [questionData];
          bestMatchRatio = similarityRatio;
        } else if (similarityRatio === bestMatchRatio) {
          // 如果相似度与当前最佳匹配相等，将问题添加到最佳匹配问题数组中
          bestMatchedQuestions.push(questionData);
        }
      }

      // 如果找到了最佳匹配问题，从中随机选择一个问题返回
      if (bestMatchedQuestions.length > 0) {
        const randomIndex = Math.floor(Math.random() * bestMatchedQuestions.length);
        return bestMatchedQuestions[randomIndex];
      } else {
        // 如果找不到相似问题，返回 null
        return null;
      }
    },
    // 计算两个字符串的相似度
    calculateSimilarity (str1, str2) {
      // 这里使用一种简单的相似度计算方法，您也可以使用更高级的算法
      const longer = str1.length > str2.length ? str1 : str2;
      const shorter = str1.length > str2.length ? str2 : str1;
      const longerLength = longer.length;

      if (longerLength === 0) {
        return 1.0;
      }

      return (longerLength - this.calculateEditDistance(longer, shorter)) / parseFloat(longerLength);
    },
    // 计算编辑距离（Edit Distance）
    calculateEditDistance (str1, str2) {
      // 这是一个常见的编辑距离算法，用于计算两个字符串之间的距离
      // 您可以根据需要使用更高级的算法
      const matrix = [];

      for (let i = 0; i <= str2.length; i++) {
        matrix[i] = [i];
      }

      for (let j = 0; j <= str1.length; j++) {
        matrix[0][j] = j;
      }

      for (let i = 1; i <= str2.length; i++) {
        for (let j = 1; j <= str1.length; j++) {
          if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
            matrix[i][j] = matrix[i - 1][j - 1];
          } else {
            matrix[i][j] = Math.min(
              matrix[i - 1][j - 1] + 1,
              Math.min(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1)
            );
          }
        }
      }

      return matrix[str2.length][str1.length];
    }

  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-menu-inline {
  width: 100%;
  height: 100%;
}
::v-deep .ant-menu-inline.ant-menu-root .ant-menu-item {
  height: 100%;
}
::v-deep .ant-menu-item-selected {
  color: #e3f2fd;
  background: white;
}
::v-deep .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  // background: white;
  background: none;
}
::v-deep .ant-menu-item::after {
  border-right: none;
}
::v-deep .ant-btn,
.ant-btn-primary:focus {
  border-radius: var(--Radius-S, 12rem);
  width: 88rem;
  height: 36rem;
  font-size: 14rem;
}
::v-deep .ant-modal-footer {
  width: 100%;
  display: flex; /* 使用 flex 布局 */
  justify-content: center; /* 将按钮右对齐 */
  align-items: center; /* 垂直居中对齐 */
  border-top: none;
}
.ant-input {
  border-radius: var(--Radius-M, 20rem);
  background: #fff;
}
.el-menu--collapse {
  width: 100rem;
}
.el-menu {
  background: var(--light-fafafa, #fafafa);
}
.el-button {
  ::v-deep div {
    display: flex;
    align-items: center;
    gap: 2rem;
  }
}
.el-menu-item.is-active {
  // position: absolute;
  // top:800rem
  color: #999;
}
.analysis_warp {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #f6f6f6;

  .top {
    width: 100vw;
    height: 100rem;
    position: absolute;
    ::v-deep img {
      z-index: 1;
      left: 20rem;
      width: 48rem;
      height: 48rem;
    }
    ::v-deep .tab {
      margin-left: 204rem;
    }
  }

  .content {
    display: flex;
    // height: calc(100vh - 100rem);
    $color_1: #18a058;

    justify-content: space-between;
    background: #f2f2f2;
    height: 100%;
    overflow: hidden;
    .left {
      height: 100%;

      .add {
        display: flex;
        width: 48rem;
        height: 48rem;
        margin-bottom: 24rem;
        // padding: 0rem var(--Spacing-M, 16rem);
        justify-content: center;
        align-items: center;
        top: 120rem;
        position: absolute;
        gap: var(--Spacing-S, 8rem);
        border-radius: var(--Radius-S, 12rem);
        border: 1rem solid var(--Brand-Color_6default, #2196f3);
      }
    }
    .chat-gpt-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      position: relative;
      // padding: 0.5208vw;
      .bottom_text {
        display: flex;
        justify-content: center;
        color: var(--light-999999, #999);

        font-size: 16rem;
        font-style: normal;
        font-weight: 400;
        line-height: 24rem; /* 150% */
      }
      .input-area-tit {
        width: 100%;
        margin-top: 277rem;
        .text {
          color: var(--light-333333, #333);
          text-align: center;

          font-size: 28rem;
          font-style: normal;
          font-weight: 600;
          line-height: 42rem; /* 150% */
        }
        .text1 {
          color: var(--light-333333, #333);
          text-align: center;

          font-size: 16rem;
          font-style: normal;
          font-weight: 400;
          line-height: 24rem; /* 150% */
        }
      }
      .chat-area {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        margin-top: 100rem;
        .message {
          .message-bubble.c_res {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-left: 450rem;
            width: 793rem;
            .c_page {
              display: flex;
              align-items: center;
              gap: var(--Spacing-XS, 4rem);
            }
          }
          .message-bubble.machine-responseload {
            display: flex;
            align-items: flex-start;
            justify-content: flex-end;
            margin-left: -70rem;
            .skeleton {
              flex: 1;
              border-radius: 0.3125vw;

              background: #fff;
              min-height: 4.1667vw;
              padding: 0.5208vw 1.0417vw;
              max-width: calc(100% - 26vw);
              display: flex;
              align-items: center;
            }

            .c_cont {
              flex: 1;
              border-radius: 0.3125vw;
              overflow: auto;
              background: #fff;
              padding: 13rem;
              max-width: calc(100% - 12vw);
              display: flex;
              // align-items: center;
              flex-direction: column;
              ::v-deep p {
                margin-bottom: 0em;
              }
            }
            .c_cont1 {
              flex: 1;
              border-radius: 0.3125vw;
              overflow: auto;
              background: #fff;
              padding: 16rem;
              margin-top: 8rem;
              // max-width: calc(100% - 12vw);
              display: flex;
              // align-items: center;
              flex-direction: column;
            }
          }

          .message-bubble.machine-response {
            display: flex;
            align-items: flex-start;
            justify-content: flex-end;
            margin-left: 256rem;
            .skeleton {
              flex: 1;
              border-radius: 0.3125vw;

              background: #fff;
              min-height: 4.1667vw;
              padding: 0.5208vw 1.0417vw;
              max-width: calc(100% - 19vw);
              display: flex;
              align-items: center;
            }
            .c_title {
              display: flex;
              padding: var(--Spacing-S, 8rem) var(--Spacing-M, 16rem);
              align-items: center;
              gap: var(--Spacing-S, 8rem);
              border-radius: 12rem;
              background: var(--light-eeeeee, #eee);
              width: 165rem;
            }
            .c_contdeep {
              flex: 1;
              border-radius: 0.3125vw;
              overflow: auto;
              // background: #fff;
              min-height: 4.1667vw;
              padding: 0.5208vw 1.0417vw;
              max-width: calc(100% - 12vw);
              display: flex;
              // align-items: center;
              flex-direction: column;
              color: var(--light-999999, #999);
              width: 805rem;
            }
            .c_cont {
              flex: 1;
              border-radius: 0.3125vw;
              overflow: auto;
              background: #fff;
              padding: 13rem;
              max-width: calc(100% - 19vw);
              display: flex;
              width: 1115rem;
              // align-items: center;
              flex-direction: column;
              ::v-deep p {
                margin-bottom: 0em;
              }
            }
            .c_cont1 {
              flex: 1;
              border-radius: 0.3125vw;
              overflow: auto;
              background: #fff;
              padding: 16rem;
              margin-top: 8rem;
              // max-width: calc(100% - 12vw);
              display: flex;
              // align-items: center;
              flex-direction: column;
            }
          }

          .message-bubble.user-message {
            display: flex;
            align-items: flex-start;
            justify-content: flex-end;
            .c_cont {
              // flex: 1;
              border-radius: 0.3125vw;
              // overflow: auto;
              background: #e3f2fd;
              padding: 13rem;
              // max-width: calc(100% - 26vw);
              display: flex;
              align-items: center;
              flex-direction: column;
            }
            .c_cont1 {
              flex: 1;
              border-radius: 0.3125vw;
              overflow: auto;
              background: #e3f2fd;
              padding: 16rem;
              margin-top: 8rem;
              // max-width: calc(100% - 12vw);
              display: flex;
              // align-items: center;
              flex-direction: column;
              .fileChat {
          display: flex;
          width: 176rem;
          padding: var(--Spacing-S, 8rem);
          align-items: center;
          gap: var(--Spacing-S, 8rem);
          border-radius: var(--Radius-S, 12rem);
          background: var(--light-f-5-f-5-f-5, #f5f5f5);
       
          .imgText {
            color: var(--light-333333, #333);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 96rem; /* 设置容器宽度 */

            // padding: 5rem;
            display: block; /* 确保宽度生效 */
            font-size: 12rem;
            font-style: normal;
            font-weight: 400;
            line-height: 20rem; /* 166.667% */
          }
          .text {
            display: flex;
            align-items: center;
            gap: var(--Spacing-S, 8rem);
            align-self: stretch;
            .imgText {
              color: var(--light-333333, #333);
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 96rem; /* 设置容器宽度 */

              // padding: 5rem;
              display: block; /* 确保宽度生效 */
              font-size: 12rem;
              font-style: normal;
              font-weight: 400;
              line-height: 20rem; /* 166.667% */
            }
          }
        }
              img {
                max-width: 700rem;
              }
            }
          }

          .message-bubble {
            margin-bottom: 1.0417vw;
            display: flex;
            justify-content: end;
            width: 80%;
          }

          .c_name {
            display: flex;
            align-items: center;
            justify-content: center;
            display: flex;
            width: var(--Iconsize-XXXL, 48rem);
            height: 48rem;
            border-radius: var(--Radius-MAX, 100rem);
            border: 1rem solid var(--light-eeeeee, #eee);
            background: #ecf1f5;
            aspect-ratio: 1/1;
            color: #fff;
            font-size: 0.8333vw;
            font-weight: 600;
            margin: 0.0417vw 0.5208vw 0 0.5208vw;
          }
        }
      }
      .selectDialog{
        display: flex;
width: 320rem;
padding: var(--Spacing-S, 8rem) 0rem;
flex-direction: column;
justify-content: center;
align-items: flex-start;
border-radius: var(--Radius-S, 12rem);
border: 1rem solid var(--light-eeeeee, #EEE);
background: #FFF;
 
left: 380rem;
top:350rem;
position: absolute;
/* Web/一级阴影，0,2,4,0，10% */
box-shadow: 0rem 2rem 4rem 0rem rgba(0, 0, 0, 0.10);
.item{
  display: flex;
height: 48rem;
padding: 0rem var(--Spacing-M, 16rem);
align-items: center;
gap: var(--Spacing-S, 8rem);
align-self: stretch;
 
&:hover{
  background: var(--Brand-Color_1, #E3F2FD);
}
}
      }
.selectType{
  display: flex;
height: 40rem;
 
// width: 144rem;
padding: 0rem var(--Spacing-M, 16rem);
justify-content: center;
align-items: center;
gap: var(--Spacing-XS, 4rem);
left: 380rem;
top:473rem;
position: absolute;
border-radius: var(--Radius-S, 12rem);
background: var(--light-eeeeee, #EEE);
}
      .input-area {
        width: calc(100% - 35vw);
        display: flex;
        align-items: flex-end;
        height: 208rem;
        margin-left: 370rem;
        .ant-input{
          max-height: 164rem !important;
          min-height: 164rem !important;
          height: 164rem !important;
        }
        .fileList {
          display: flex;
          width: 176rem;
          padding: var(--Spacing-S, 8rem);
          align-items: center;
          gap: var(--Spacing-S, 8rem);
          border-radius: var(--Radius-S, 12rem);
          background: var(--light-f-5-f-5-f-5, #f5f5f5);
          position: absolute;
          margin-left: 20rem !important;
          bottom: 272rem;
          .imgText {
            color: var(--light-333333, #333);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 96rem; /* 设置容器宽度 */

            // padding: 5rem;
            display: block; /* 确保宽度生效 */
            font-size: 12rem;
            font-style: normal;
            font-weight: 400;
            line-height: 20rem; /* 166.667% */
          }
          .text {
            display: flex;
            align-items: center;
            gap: var(--Spacing-S, 8rem);
            align-self: stretch;
            .imgText {
              color: var(--light-333333, #333);
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 96rem; /* 设置容器宽度 */

              // padding: 5rem;
              display: block; /* 确保宽度生效 */
              font-size: 12rem;
              font-style: normal;
              font-weight: 400;
              line-height: 20rem; /* 166.667% */
            }
          }
        }
        .uploadDialog {
          display: flex;
          padding: var(--Spacing-S, 8rem);
          flex-direction: column;
          align-items: flex-start;
          align-self: stretch;
          border-radius: var(--Radius-S, 12rem);
          border: 1rem solid var(--light-eeeeee, #eee);
          background: #fff;
          position: absolute;
          margin-left: 774rem !important;
          bottom: 284rem;
          box-shadow: 0rem 4rem 8rem 0rem rgba(0, 0, 0, 0.1);

          .text1 {
            display: flex;
            height: 40rem;
            padding: 0rem var(--Spacing-S, 8rem);
            justify-content: center;
            align-items: center;
            gap: var(--Spacing-XS, 4rem);
            color: var(--light-666666, #666);
            text-align: center;

            font-size: 16rem;
            font-style: normal;
            font-weight: 400;
            line-height: 24rem; /* 150% */
            &:hover {
              border-radius: var(--Radius-XS, 4rem);
              background: var(--light-f-5-f-5-f-5, #f5f5f5);
            }
          }
          .text2 {
            display: flex;
            height: 40rem;
            padding: 0rem var(--Spacing-S, 8rem);
            justify-content: center;
            align-items: center;
            gap: var(--Spacing-XS, 4rem);
            border-top: 1rem solid var(--light-eeeeee, #eee);
            color: var(--light-666666, #666);
            text-align: center;

            font-size: 16rem;
            font-style: normal;
            font-weight: 400;
            line-height: 24rem; /* 150% */
            &:hover {
              border-radius: var(--Radius-XS, 4rem);
              background: var(--light-f-5-f-5-f-5, #f5f5f5);
            }
          }
        }
        .upload {
          position: absolute;
          margin-left: 806rem !important;
          bottom: 242rem;
        }

        .send_button {
          position: absolute;
          margin-left: 855rem !important;
          bottom: 46rem;
        }
        .send_buttonActive {
          position: absolute;
          left: 396rem;
          bottom: 46rem;
          display: flex;
          height: 40rem;
          padding: 0rem 20rem;
          justify-content: center;
          align-items: center;
          gap: var(--Spacing-XS, 4rem);
          border-radius: var(--Radius-MAX, 100rem);
          border: 1rem solid var(--Brand-Color_6default, #2196f3);
          background: var(--Brand-Color_1, #e3f2fd);
          color: #2196f3;
        }
        .send_button1 {
          position: absolute;
          left: 396rem;
          bottom: 46rem;
          display: flex;
          cursor: pointer;
          height: 40rem;
          padding: 0rem 20rem;
          justify-content: center;
          align-items: center;
          gap: var(--Spacing-XS, 4rem);
          cursor: pointer;
          border-radius: var(--Radius-MAX, 100rem);
          border: 1rem solid var(--light-666666, #666);
        }
        .send_buttonActive2 {
          position: absolute;
          left: 524rem;
          bottom: 46rem;
          display: flex;
          cursor: pointer;
          height: 40rem;
          padding: 0rem 20rem;
          justify-content: center;
          align-items: center;
          color: #2196f3;

          gap: var(--Spacing-XS, 4rem);
          border-radius: var(--Radius-MAX, 100rem);
          border: 1rem solid var(--light-666666, #2196f3);
        }
        .send_button2 {
          position: absolute;
          left: 524rem;
          bottom: 46rem;
          cursor: pointer;
          display: flex;
          height: 40rem;
          padding: 0rem 20rem;
          justify-content: center;
          align-items: center;
          gap: var(--Spacing-XS, 4rem);
          border-radius: var(--Radius-MAX, 100rem);
          border: 1rem solid var(--light-666666, #666);
        }
        .el-textarea {
          height: 100% !important;
          display: flex;

          ::v-deep .el-textarea__inner {
            height: 100% !important;
            border-radius: var(--Radius-M, 20rem);
            background: #fff;
            box-shadow: 0rem -10rem 10rem 0rem #f5f5f5;
          }
        }

        .el-button {
          margin: 0 0.5208vw;
        }
      }
    }
    .left_tree {
      padding-top: 100rem;
      // width: 200rem;
      overflow: auto;

      // background: var(--light-fafafa, #fafafa);
      // border-top: 2rem solid #f0f2f5;
      // max-height: 690rem;
      div {
        ::-webkit-scrollbar {
          display: none;
        }
      }
      scrollbar-width: none; /* Firefox */
      .chatIcon {
        margin-top: 500rem;
      }
      .collapse {
        display: flex;
        justify-content: flex-end;
      }
      .chat-gpt {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        font-size: 0.8333vw;

        /* 逐字显示动画 */
        .message-bubble {
          overflow: hidden;
        }

        .message-bubble[data-typing]::after {
          content: "";
          animation: typing 0.1s steps(1) infinite;
        }

        @keyframes typing {
          0% {
            width: 0;
          }

          100% {
            width: 100%;
          }
        }

        .chat-gpt-left {
          // width: 20.8333vw;
          // border: 1rem solid #ccc;
          // display: flex;
          // flex-direction: column;
          // align-items: center;
          // padding: 0 24rem;
          // min-width: 200rem;
          height: 730rem;
          width: 100%;
          .line {
            border-bottom: 1rem solid var(--light-eeeeee, #eee);
            margin: 16rem 0 16rem 0;
            // width: 150%;
          }
          .search {
            display: flex;
            align-items: center;
            gap: var(--Spacing-S, 8rem);
            align-self: stretch;
            justify-content: center;
            .searchInput {
              display: flex;
              gap: 8rem;
              align-items: center;
              margin-bottom: 12rem;
              width: 240rem;
              .btn {
                display: flex;
                height: 48rem;
                padding: 0rem var(--Spacing-M, 16rem);
                justify-content: center;
                align-items: center;
                gap: var(--Spacing-S, 8rem);
                flex: 1 0 0;
                border-radius: var(--Radius-S, 12rem);
                background: var(--light-f-5-f-5-f-5, #f5f5f5);
                color: #f2413a;
              }
              .btn1 {
                display: flex;
                height: 48rem;
                padding: 0rem var(--Spacing-M, 16rem);
                justify-content: center;
                align-items: center;
                gap: var(--Spacing-S, 8rem);
                flex: 1 0 0;
                border-radius: var(--Radius-S, 12rem);
                background: var(--light-f-5-f-5-f-5, #f5f5f5);
                color: #666;
              }
              .image_btn {
                background: var(--light-f-5-f-5-f-5, #f5f5f5);
                width: 48rem;
                border-radius: var(--Radius-S, 12rem);
                display: flex;
                height: 48rem;
                justify-content: center;
                align-items: center;
                aspect-ratio: 1/1;
              }
              ::v-deep .ant-input {
                height: 48rem;
                border-radius: var(--Radius-S, 12rem);
                background: var(--light-f-5-f-5-f-5, #f5f5f5);
              }
            }
          }
          .item_btn {
            display: flex;
            height: 48rem;
            padding: 0rem var(--Spacing-M, 16rem);
            align-items: center;
            gap: var(--Spacing-S, 8rem);
            align-self: stretch;
            width: 92%;

            border-radius: var(--Radius-S, 12rem);
            border: 1rem solid var(--Brand-Color_6default, #2196f3);
            color: #fff;

            color: var(--Brand-Color_6default, #2196f3);
            font-size: 16rem;
            font-style: normal;
            font-weight: 400;
            line-height: 24rem; /* 150% */
            justify-content: flex-start;
            cursor: pointer;
          }
          .left_list {
            height: 650rem;
            overflow: auto;
            // padding: 16rem;
            div {
              ::-webkit-scrollbar {
                display: none;
              }
            }
            scrollbar-width: none; /* Firefox */
          }
          .item_c_list {
            width: 100%;
            flex: 1;
            width: 100%;
            display: flex;
            flex-direction: column;
            color: #999;
            .item_c {
              width: 100%;
              display: flex;
              align-items: center;
              padding-left: 8rem;
              height: 2.9167vw;
              gap: 8rem;
              max-width: 250rem;
              // justify-content: space-between;
              overflow: hidden;
              color: var(--light-333333, #333);

              font-size: 16rem;
              font-style: normal;
              font-weight: 400;
              line-height: 24rem; /* 150% */
              border-radius: 0.3125vw;
              margin: 0 0 0.5208vw 0;
              cursor: pointer;

              p {
                display: flex;
                align-items: center;

                &:nth-child(1) {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                }
              }

              i {
                margin: 0 0.2604vw;
                font-size: 1.25vw;
                color: $color_1;
                cursor: pointer;
              }

              &.active {
                // border: 1rem solid $color_1;
                // background: rgba($color: $color_1, $alpha: 0.1);
                border-radius: var(--Radius-S, 12rem);
                background: var(--Brand-Color_1, #e3f2fd);
              }
            }
          }
        }
      }
    }

    .vue-codemirror {
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .CodeMirror {
      height: auto !important;
      flex: 1;
    }

    .CodeMirror-sizer {
      margin-bottom: 0 !important;
    }
  }
}
.fixed_btn {
  position: fixed;
  top: 50rem;
  right: 30rem;
  font-size: 24rem;
  display: flex;
  // width: 350rem;
  div {
    // flex: 1;
    text-align: center;
  }
  img {
    width: 36rem;
    height: 36rem;
    margin-left: 30rem;
  }
}
.topic {
  font-size: 20rem;
}
</style>